import { render, staticRenderFns } from "./chengXinContent.vue?vue&type=template&id=0859b2b4&scoped=true"
import script from "./chengXinContent.vue?vue&type=script&lang=js"
export * from "./chengXinContent.vue?vue&type=script&lang=js"
import style0 from "./chengXinContent.vue?vue&type=style&index=0&id=0859b2b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859b2b4",
  null
  
)

export default component.exports